export function numberToCurrency(number, options = {}) {
  const defaults = {
    locale: 'en-US',
    currency: 'USD',
    style: 'currency'
  };
  const { locale, ...config } = { ...defaults, ...options };
  let num = Number.isNaN(number) ? 0 : number;

  if (num === null) return Number(0).toLocaleString(locale, config);
  if (typeof num === 'string') num = num.replace(/[,]/g, '');

  return Number(typeof num === 'object' ? num.value : num).toLocaleString(locale, config);
}

export function numberToDecimal(number, options) {
  const defaults = {
    locale: 'en-US',
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  };
  const { locale, ...config } = { ...defaults, ...options };
  const numberVal = typeof number === 'string' ? number.replace(',','') : number;
  if (!numberVal) return Number(0).toLocaleString(locale, config);
  return Number(typeof numberVal === 'object' ? numberVal.value : numberVal).toLocaleString(locale, config);
}

export function nachaToDecimal(number) {
  return Number((Number(number) / 100).toFixed(2));
}

export function currencyToNumber(currency) {
  return Number(currency.replace(/[^0-9.-]+/g, ''));
}

export function formatNegativeNumber(number) {
  // strip commas
  return Number(currencyToNumber(number)) < 0 ? `(${number.toString().split('-')[1]})` : number;
}
